import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAEbroucher, getEbrouchers, resetState } from "../features/EbrouchersSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Logo",
    dataIndex: "logo",
    render: logo => <img src={logo} alt="Ebroucher Logo" style={{ width: 50, height: 50 }} />,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const EbrouchersList = () => {
  const [open, setOpen] = useState(false);
  const [EbroucherId, setEbroucherId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setEbroucherId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getEbrouchers());
  }, []);
  const getEbroucherState = useSelector((state) => state.Ebroucher.Ebrouchers);
  console.log(getEbroucherState);
  const data1 = [];
  console.log(getEbroucherState.length);
  for (let i = 0; i < getEbroucherState.length; i++) {
    data1.push({
      key: i + 1,
      logo: getEbroucherState[i].thumbnail,

      action: (
        <>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getEbroucherState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteAEbroucher(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getEbrouchers());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Ebroucher List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(EbroucherId);
        }}
        title="Are you sure you want to delete this Ebroucher?"
      />
    </div>
  );
};

export default EbrouchersList;
